const InterviewConnectionErrors = {
    waitingRoom: 'waitingRoom',
    moderatorConnected: 'moderatorConnected',
};

export default InterviewConnectionErrors;
